import { apiCall } from "./index";

export const getUsers = (page = 1, limit = 10) => apiCall(`/users?page=${page}&limit=${limit}`);

export const getUserById = (userId) => apiCall(`/users/${userId}`);

export const createUser = (userData) => apiCall(`/users`, "POST", userData);

export const updateUser = (userId, userData) => apiCall(`/users/${userId}`, "PUT", userData);

export const deleteUser = (userId) => apiCall(`/users/${userId}`, "DELETE");

export const changeUserStatus = (userId, status) => {
  return apiCall(`/users/status/${status}/${userId}`, "PUT");
};

export const getSelectedUsers = (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  return apiCall(`/users/selected?${queryParams}`);
};

export const getPendingUsers = (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  return apiCall(`/users/pending?${queryParams}`);
};

export const getRejectedUsers = (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  return apiCall(`/users/rejected?${queryParams}`);
};

export const getShortlistedUsers = (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  return apiCall(`/users/shortlisted?${queryParams}`);
};

export const usersVisibleLeavePolicy = (user) => {
  console.log(user);
  return apiCall(`/users/${user}/leave-policies/visible`);
};

// export const getUserLeaveBalances = (userId, year = 2025) => {
//   return apiCall(`/users/${userId}/leave-balances?year=${year}`);
// };



// export const getMyLeaveRequests = (params = {}) => {
//   const queryParams = new URLSearchParams(params).toString();
//   return apiCall(`/me/leave-requests?${queryParams}`);
// };

export const getMyLeaveRequests = (params = {}, userId = null) => {
  const queryParams = new URLSearchParams(params).toString();

  // 🔹 If team user id present → user specific endpoint
  if (userId) {
    return apiCall(`/me/${userId}/leave-requests?${queryParams}`);
  }

  // 🔹 Default → logged-in user
  return apiCall(`/me/leave-requests?${queryParams}`);
};


export const getLeaveHistory = (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  return apiCall(`admin/all-leave-requests?${queryParams}`);
};

export const teamLeaveSummary = (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  return apiCall(`/team-leave-summary?${queryParams}`);
};

export const getAdminLeaveRequests = (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  return apiCall(`/admin/leave-requests?${queryParams}`);
};

export const createLeaveRequest = (leaveRequestData) => {
  console.log(leaveRequestData);
  return apiCall(`/leave-requests`, "POST", leaveRequestData);
};

// Approve leave request (for admin)
export const approveLeaveRequest = (leaveRequestId, approveReason) => {
  return apiCall(`/admin/leave-requests/${leaveRequestId}/decision`, "POST", {
    action: "approve",
    status_reason: approveReason,
  });
};

// Reject leave request (for admin)
export const rejectLeaveRequest = (leaveRequestId, rejectReason) => {
  const res = apiCall(`/admin/leave-requests/${leaveRequestId}/decision`, "POST", {
    action: "reject",
    status_reason: rejectReason,
  });
  return res;
};

// Get leave request by ID
export const getLeaveRequestById = (leaveRequestId) => {
  return apiCall(`/leave-requests/${leaveRequestId}`);
};

// Update leave request
export const updateLeaveRequest = (leaveRequestId, leaveRequestData) => {
  return apiCall(`/leave-requests/${leaveRequestId}`, "PUT", leaveRequestData);
};

// Delete leave request
export const deleteLeaveRequest = (leaveRequestId) => {
  return apiCall(`/leave-requests/${leaveRequestId}`, "DELETE");
};

// Cancel leave request
export const cancelLeaveRequest = (leaveRequestId, cancelReason) => {
  return apiCall(`/leave-requests/${leaveRequestId}/cancel`, "POST", {
    status_reason: cancelReason,
  });
};

export const cancelMyLeaveRequest = (leaveRequestId, cancelReason) => {
  return apiCall(`/me/leave-requests/${leaveRequestId}/cancel`, "POST", {
    status_reason: cancelReason,
  });
};

// Add to users.js

// Salary related APIs
export const getEmployeeSalaryDetails = (employeeId, month) => {
  return apiCall(`/users/${employeeId}/salary?month=${month}`);
};

export const getTeamSalary = (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  return apiCall(`/team/salary?${queryParams}`);
};
